import APIBase from "./apiBase";

export interface Challenge {
  id: string;
  token: string;
}

export const createChallenge = async (messageId: string, doSend: boolean) => {
  const { data } = await APIBase.post<Challenge>(
    `/challenges/${messageId}`,
    null,
    { params: { doSend: doSend } }
  );
  return data;
};

export const sendTestChallenge = async (inboxId: string) => {
  const { data } = await APIBase.post(`/challenges/test`, null, {
    params: { inboxId },
  });
  return data;
};
